'use client';

import Link from 'next/link';
import { Pencil } from 'lucide-react';
import { useAuth } from '@/components/AuthProvider';
import { usePolicy } from '@/lib/hooks/usePolicy';

interface ArticleAdminEditLinkProps {
  articleId: number;
  authorId?: number | null;
  editorId?: number | null;
}

/**
 * Public haber sayfasında: admin/editör girişliyse ve news.update yetkisi varsa
 * admin düzenleme sayfasına link gösterir.
 */
export default function ArticleAdminEditLink({
  articleId,
  authorId,
  editorId,
}: ArticleAdminEditLinkProps) {
  const { isLoggedIn, isLoading } = useAuth();
  const { can, loading: policyLoading } = usePolicy();

  if (isLoading || policyLoading || !isLoggedIn) return null;

  const allowed = can('news', 'update', {
    resourceId: articleId,
    authorId: authorId ?? undefined,
    ownerId: authorId ?? editorId ?? undefined,
  });

  if (!allowed) return null;

  return (
    <Link
      href={`/admin/articles/${articleId}/edit`}
      className="mt-1 inline-flex shrink-0 items-center gap-1.5 self-start rounded-lg border border-[#D92E2E]/40 bg-[#D92E2E]/10 px-2.5 py-1 text-xs font-semibold text-[#D92E2E] transition-colors hover:bg-[#D92E2E]/20 dark:border-red-500/40 dark:bg-red-950/40 dark:text-red-300 dark:hover:bg-red-950/70 sm:mt-1.5"
      title="Haberi admin panelinde düzenle"
    >
      <Pencil className="h-3.5 w-3.5" aria-hidden />
      Düzenle
    </Link>
  );
}
